import { ErrorFallback, OptimizationUtils, SuspenseWrapper } from "@/lib/main";
import { RouteObject } from "react-router";

const { lazyWithRetry } = OptimizationUtils;

const Alerts = lazyWithRetry(() => import("@/src/pages/interactions/Alerts"));
const Animations = lazyWithRetry(
  () => import("@/src/pages/interactions/Animations"),
);
const Aside = lazyWithRetry(() => import("@/src/pages/navigation/Aside"));
const Avatars = lazyWithRetry(() => import("@/src/pages/graphics/Avatars"));
const Branding = lazyWithRetry(() => import("@/src/pages/graphics/Branding"));
const Buttons = lazyWithRetry(() => import("@/src/pages/interactions/Buttons"));
const Cards = lazyWithRetry(() => import("@/src/pages/visualizations/Cards"));
const Charts = lazyWithRetry(() => import("@/src/pages/visualizations/Charts"));
const Chips = lazyWithRetry(() => import("@/src/pages/interactions/Chips"));
const Containers = lazyWithRetry(() => import("@/src/pages/layout/Containers"));
const Errors = lazyWithRetry(() => import("@/src/pages/interactions/Errors"));
const Footer = lazyWithRetry(() => import("@/src/pages/navigation/Footer"));
const Forms = lazyWithRetry(() => import("@/src/pages/interactions/Forms"));
const Home = lazyWithRetry(() => import("@/src/pages/Home"));
const LibraryLayout = lazyWithRetry(
  () => import("@/src/layouts/LibraryLayout"),
);
const Playground = lazyWithRetry(() => import("@/src/pages/Playground"));
const Icons = lazyWithRetry(() => import("@/src/pages/graphics/Icons"));
const Images = lazyWithRetry(() => import("@/src/pages/graphics/Images"));
const Illustrations = lazyWithRetry(
  () => import("@/src/pages/graphics/Illustrations"),
);
const LibraryPage = lazyWithRetry(() => import("@/src/pages/LibraryPage"));
const Metrics = lazyWithRetry(
  () => import("@/src/pages/visualizations/Metrics"),
);
const NotFound = lazyWithRetry(() => import("@/src/pages/NotFound"));
const OtherInteractions = lazyWithRetry(
  () => import("@/src/pages/interactions/OtherInteractions"),
);
const OtherNavigation = lazyWithRetry(
  () => import("@/src/pages/navigation/OtherNavigation"),
);
const Header = lazyWithRetry(() => import("@/src/pages/navigation/Header"));
const Settings = lazyWithRetry(
  () => import("@/src/pages/interactions/Settings"),
);
const Suspense = lazyWithRetry(
  () => import("@/src/pages/interactions/Suspense"),
);
const Tables = lazyWithRetry(() => import("@/src/pages/visualizations/Tables"));
const Typography = lazyWithRetry(
  () => import("@/src/pages/foundations/Typography"),
);

const routes: RouteObject[] = [
  {
    element: <LibraryLayout />,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: "/playground",
        element: (
          <SuspenseWrapper>
            <Playground />
          </SuspenseWrapper>
        ),
      },
      {
        index: true,
        element: (
          <SuspenseWrapper>
            <Home />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/lib/:category",
        element: (
          <SuspenseWrapper>
            <LibraryPage />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/alerts",
        element: (
          <SuspenseWrapper>
            <Alerts />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/animations",
        element: (
          <SuspenseWrapper>
            <Animations />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/aside",
        element: (
          <SuspenseWrapper>
            <Aside />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/avatars",
        element: (
          <SuspenseWrapper>
            <Avatars />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/branding",
        element: (
          <SuspenseWrapper>
            <Branding />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/buttons",
        element: (
          <SuspenseWrapper>
            <Buttons />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/cards",
        element: (
          <SuspenseWrapper>
            <Cards />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/charts",
        element: (
          <SuspenseWrapper>
            <Charts />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/chips",
        element: (
          <SuspenseWrapper>
            <Chips />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/containers",
        element: (
          <SuspenseWrapper>
            <Containers />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/errors",
        element: (
          <SuspenseWrapper>
            <Errors />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/footer",
        element: (
          <SuspenseWrapper>
            <Footer />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/forms",
        element: (
          <SuspenseWrapper>
            <Forms />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/icons",
        element: (
          <SuspenseWrapper>
            <Icons />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/illustrations",
        element: (
          <SuspenseWrapper>
            <Illustrations />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/images",
        element: (
          <SuspenseWrapper>
            <Images />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/metrics",
        element: (
          <SuspenseWrapper>
            <Metrics />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/other-interactions",
        element: (
          <SuspenseWrapper>
            <OtherInteractions />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/other-navigation",
        element: (
          <SuspenseWrapper>
            <OtherNavigation />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/header",
        element: (
          <SuspenseWrapper>
            <Header />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/settings",
        element: (
          <SuspenseWrapper>
            <Settings />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/suspense",
        element: (
          <SuspenseWrapper>
            <Suspense />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/tables",
        element: (
          <SuspenseWrapper>
            <Tables />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/typography",
        element: (
          <SuspenseWrapper>
            <Typography />
          </SuspenseWrapper>
        ),
      },
      {
        path: "*",
        element: (
          <SuspenseWrapper>
            <NotFound />
          </SuspenseWrapper>
        ),
      },
    ],
  },
];

export default routes;
